import spaceStyles from '@creditflowresearch/uilib/styles/helpers/spaces.module.scss';

export const columns = [
  {
    name: 'cusip',
    title: 'cusip #',
    width: 112,
    minWidth: 112,
    maxWidth: 112,
    className: spaceStyles.pll,
  },
  {
    name: 'name',
    title: 'bond',
    width: 188,
    minWidth: 188,
    maxWidth: 188,
  },
  {
    name: 'currencyId',
    title: 'ССY',
    width: 91,
    minWidth: 91,
  },
  {
    name: 'positionSize',
    title: 'Position Size',
    width: 215,
    minWidth: 215,
  },
  {
    name: 'dollarPricePaid',
    title: 'Dollar Price Paid',
    width: 215,
    minWidth: 215,
  },
  {
    name: 'datePurchased',
    title: 'Date Purchased',
    maxWidth: 215,
    minWidth: 215,
  },
  {
    name: '',
    maxWidth: 53,
    minWidth: 53,
  },
];
